var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_964_9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0039 13.2812H27.4414C27.1484 13.2812 26.8555 13.0859 26.8555 12.6953C26.8555 12.4023 27.1484 12.1094 27.4414 12.1094H29.0039C29.2969 12.1094 29.5898 12.4023 29.5898 12.6953C29.5898 13.0859 29.2969 13.2812 29.0039 13.2812ZM23.0469 13.2812H7.91016C7.61719 13.2812 7.32422 13.0859 7.32422 12.6953C7.32422 12.4023 7.61719 12.1094 7.91016 12.1094H23.0469C23.4375 12.1094 23.6328 12.4023 23.6328 12.6953C23.6328 13.0859 23.4375 13.2812 23.0469 13.2812ZM29.0039 19.043H20.7031C20.3125 19.043 20.1172 18.8477 20.1172 18.457C20.1172 18.1641 20.3125 17.8711 20.7031 17.8711H29.0039C29.2969 17.8711 29.5898 18.1641 29.5898 18.457C29.5898 18.8477 29.2969 19.043 29.0039 19.043ZM16.3086 19.043H7.91016C7.61719 19.043 7.32422 18.8477 7.32422 18.457C7.32422 18.1641 7.61719 17.8711 7.91016 17.8711H16.3086C16.6016 17.8711 16.8945 18.1641 16.8945 18.457C16.8945 18.8477 16.6016 19.043 16.3086 19.043ZM29.0039 24.8047H13.8672C13.5742 24.8047 13.2812 24.5117 13.2812 24.2188C13.2812 23.9258 13.5742 23.6328 13.8672 23.6328H29.0039C29.2969 23.6328 29.5898 23.9258 29.5898 24.2188C29.5898 24.5117 29.2969 24.8047 29.0039 24.8047ZM9.47266 24.8047H7.91016C7.61719 24.8047 7.32422 24.5117 7.32422 24.2188C7.32422 23.9258 7.61719 23.6328 7.91016 23.6328H9.47266C9.86328 23.6328 10.0586 23.9258 10.0586 24.2188C10.0586 24.5117 9.86328 24.8047 9.47266 24.8047Z",
    fill: "url(#paint0_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.293 15.5273C23.7305 15.5273 22.4609 14.2578 22.4609 12.6953C22.4609 11.2305 23.7305 9.96094 25.293 9.96094C26.7578 9.96094 28.0273 11.2305 28.0273 12.6953C28.0273 14.2578 26.7578 15.5273 25.293 15.5273ZM25.293 11.1328C24.4141 11.1328 23.6328 11.8164 23.6328 12.6953C23.6328 13.6719 24.4141 14.3555 25.293 14.3555C26.1719 14.3555 26.8555 13.6719 26.8555 12.6953C26.8555 11.8164 26.1719 11.1328 25.293 11.1328ZM18.457 21.2891C16.9922 21.2891 15.7227 20.0195 15.7227 18.457C15.7227 16.9922 16.9922 15.7227 18.457 15.7227C20.0195 15.7227 21.2891 16.9922 21.2891 18.457C21.2891 20.0195 20.0195 21.2891 18.457 21.2891ZM18.457 16.8945C17.5781 16.8945 16.8945 17.5781 16.8945 18.457C16.8945 19.3359 17.5781 20.1172 18.457 20.1172C19.3359 20.1172 20.1172 19.3359 20.1172 18.457C20.1172 17.5781 19.3359 16.8945 18.457 16.8945ZM11.7188 26.9531C10.1562 26.9531 8.88672 25.7812 8.88672 24.2188C8.88672 22.6562 10.1562 21.3867 11.7188 21.3867C13.1836 21.3867 14.4531 22.6562 14.4531 24.2188C14.4531 25.7812 13.1836 26.9531 11.7188 26.9531ZM11.7188 22.5586C10.8398 22.5586 10.0586 23.3398 10.0586 24.2188C10.0586 25.0977 10.8398 25.7812 11.7188 25.7812C12.5977 25.7812 13.2812 25.0977 13.2812 24.2188C13.2812 23.3398 12.5977 22.5586 11.7188 22.5586Z",
    fill: "url(#paint1_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.457 34.1797C14.2578 34.1797 10.3516 32.5195 7.42188 29.5898C1.26953 23.4375 1.26953 13.4766 7.42188 7.42188C10.3516 4.39453 14.2578 2.83203 18.457 2.83203C22.6562 2.83203 26.5625 4.39453 29.5898 7.42188C32.5195 10.3516 34.1797 14.2578 34.1797 18.457C34.1797 22.6562 32.5195 26.5625 29.5898 29.5898C26.5625 32.5195 22.6562 34.1797 18.457 34.1797ZM18.457 4.00391C14.5508 4.00391 10.9375 5.46875 8.20312 8.20312C2.53906 13.8672 2.53906 23.0469 8.20312 28.7109C10.9375 31.4453 14.5508 33.0078 18.457 33.0078C22.3633 33.0078 25.9766 31.4453 28.7109 28.7109C31.4453 25.9766 33.0078 22.3633 33.0078 18.457C33.0078 14.6484 31.4453 10.9375 28.7109 8.20312C25.9766 5.46875 22.3633 4.00391 18.457 4.00391Z",
    fill: "url(#paint2_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.457 36.9141C13.5742 36.9141 8.88672 35.0586 5.37109 31.543C1.95312 28.0273 0 23.4375 0 18.457C0 13.5742 1.95312 8.88672 5.37109 5.37109C8.88672 1.95312 13.5742 0 18.457 0C23.4375 0 28.0273 1.95312 31.543 5.37109C35.0586 8.88672 36.9141 13.5742 36.9141 18.457C36.9141 23.4375 35.0586 28.0273 31.543 31.543C28.0273 35.0586 23.4375 36.9141 18.457 36.9141ZM18.457 1.17188C13.8672 1.17188 9.47266 2.92969 6.25 6.25C2.92969 9.47266 1.17188 13.8672 1.17188 18.457C1.17188 23.1445 2.92969 27.4414 6.25 30.7617C9.47266 33.9844 13.8672 35.7422 18.457 35.7422C23.1445 35.7422 27.4414 33.9844 30.6641 30.7617C33.9844 27.4414 35.7422 23.1445 35.7422 18.457C35.7422 13.8672 33.9844 9.47266 30.6641 6.25C27.4414 2.92969 23.1445 1.17188 18.457 1.17188Z",
    fill: "url(#paint3_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7422 36.3281C35.5469 36.3281 35.4492 36.2305 35.3516 36.1328L30.6641 31.543C30.4688 31.3477 30.4688 30.957 30.6641 30.7617C30.957 30.4688 31.3477 30.4688 31.543 30.7617L36.1328 35.3516C36.4258 35.5469 36.4258 35.9375 36.1328 36.1328C36.0352 36.2305 35.9375 36.3281 35.7422 36.3281Z",
    fill: "url(#paint4_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2891 50C45.2148 50 44.3359 49.6094 43.5547 48.9258L35.3516 40.625C33.8867 39.1602 33.8867 36.8164 35.3516 35.3516C36.0352 34.668 37.0117 34.2773 37.9883 34.2773C38.9648 34.2773 39.9414 34.668 40.625 35.3516L48.9258 43.5547C50.3906 45.0195 50.3906 47.4609 48.9258 48.9258C48.2422 49.6094 47.2656 50 46.2891 50ZM37.9883 35.4492C37.3047 35.4492 36.6211 35.6445 36.1328 36.1328C35.1562 37.207 35.1562 38.7695 36.1328 39.8438L44.4336 48.0469C44.9219 48.5352 45.5078 48.8281 46.2891 48.8281C46.9727 48.8281 47.5586 48.5352 48.0469 48.0469C49.1211 47.0703 49.1211 45.4102 48.0469 44.4336L39.8438 36.1328C39.3555 35.6445 38.6719 35.4492 37.9883 35.4492Z",
    fill: "url(#paint5_linear_964_9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3828 47.4609C42.2852 47.4609 42.0898 47.4609 41.9922 47.3633L36.9141 42.1875C36.7188 41.9922 36.7188 41.6016 36.9141 41.4062L41.4062 36.9141C41.6016 36.7188 41.9922 36.7188 42.1875 36.9141L47.3633 41.9922C47.5586 42.2852 47.5586 42.5781 47.3633 42.8711L42.8711 47.3633C42.6758 47.4609 42.5781 47.4609 42.3828 47.4609ZM38.1836 41.7969L42.3828 46.0938L46.0938 42.3828L41.7969 38.1836L38.1836 41.7969Z",
    fill: "url(#paint6_linear_964_9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_964_9",
    x1: 36.3809,
    y1: 18.457,
    x2: 0.533202,
    y2: 18.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_964_9",
    x1: 33.8652,
    y1: 18.457,
    x2: 3.04883,
    y2: 18.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_964_9",
    x1: 43.7482,
    y1: 18.5059,
    x2: -6.76087,
    y2: 18.5059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_964_9",
    x1: 48.1728,
    y1: 18.457,
    x2: -11.2588,
    y2: 18.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_964_9",
    x1: 38.1322,
    y1: 33.4351,
    x2: 28.7379,
    y2: 33.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_964_9",
    x1: 54.8347,
    y1: 42.1387,
    x2: 29.4426,
    y2: 42.1387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_964_9",
    x1: 50.7861,
    y1: 42.1143,
    x2: 33.4912,
    y2: 42.1143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12CE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8B5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_964_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillters);
export default __webpack_public_path__ + "static/media/fillters.01b1f539bdf43ba41f2d6098f4758e2c.svg";
export { ForwardRef as ReactComponent };